module.exports = "/assets/dist/images/how-it-works-car.svg?d7b984150fd58602640232d5add60fb0";